import { SPI, BasePackWidget, DefaultTabsWidget } from '@kunlun/dependencies';

@SPI.ClassFactory(BasePackWidget.Token({ widget: 'tabs' }))
export class CustomDefaultTabsWidget extends DefaultTabsWidget {
  protected resetInvisible(): void {
    super.resetInvisible();
    const { invisibleFlags, activeIndex } = this.collectionInvisibleFlags();
    if (activeIndex !== -1) {
      const nextActiveIndex = this.findNextActiveIndex(invisibleFlags, activeIndex);
      if (nextActiveIndex !== -1) {
        const nextActiveKey = this.getChildren()[nextActiveIndex].getHandle();
        this.setActiveKey(nextActiveKey);
      }
    } else if (activeIndex === -1) {
      const index = invisibleFlags.findIndex((v) => !v);

      if (index > -1) {
        const nextActiveKey = this.getChildren()[index].getHandle();
        this.setActiveKey(nextActiveKey);
      }
    }
  }
}
